import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import css from './index.scss';
import { truncateCharacters } from '../../helpers/utils';

class ClassInfo extends PureComponent {
    render() {
        const { group, isMultiSelect } = this.props;
        let radioButton = '';
        let groupStyle = `${css.groupInfo}`;
        const elementId = `rb_${group.id}_${group.classId}`;
        if (isMultiSelect) {
            radioButton = (<div> <input
                checked={group.isDefault}
                className={css.group}
                id={elementId}
                name={elementId}
                onChange={this.props.onGroupSelection}
                type="radio"
            /><label htmlFor={elementId} />
            </div>);

            if (group.isDefault) {
                groupStyle = `${css.groupInfo} ${css.highlight}`;
            }
        }

        const groupName = truncateCharacters('group', group.name);
        const courseName = truncateCharacters('course', group.courseName);

        return (
            <div>
                <div className={groupStyle}>
                    <div className={css.radio}>
                        {radioButton}
                        <div className={css.info}>
                            <span className={css.groupName}>{groupName}</span>
                            <span className={css.courseName}>{courseName}</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ClassInfo.propTypes = {
    group: PropTypes.object,
    isMultiSelect: PropTypes.bool,
    onGroupSelection: PropTypes.func
};

export default (styleable(css)(ClassInfo));



// WEBPACK FOOTER //
// ./app/components/group-info/index.js